/*
 * Define a form page asking the user to decide if they previously reported the issue.
 */
import css from './pages.module.css'
import { yesNoPage } from './choicePage'

export const previouslyReportedPage = propOverrides => {
  const props = {
    pageId: 'previously_reported_page',
    fieldName: 'previously_reported',
    label: 'Has this previously been reported to anyone?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
